<template>
  <DKitSupportPanel
    v-if="bearer"
    v-model="model"
    :api-token="bearer"
    app-id="deepbox"
    :chat-api-token="apiToken"
    :env="env"
    :user="user"
  />
</template>

<script setup lang="ts">
import { DKitSupportPanel } from '@deepcloud/deep-ui-kit'
import { useKeycloak } from '@/composables/auth/keycloak'

const model = defineModel({
  type: Boolean,
  default: false,
})

const apiToken = import.meta.env.VITE_APP_DEEP_CHAT_API_KEY
const env = import.meta.env.VITE_ENVIRONMENT

const { user, bearer } = useKeycloak()
</script>
